<template>
  <div style="height:100vh;width:100vw;">
        <img src="https://image.begonia.cafe/tx/00166.webp" referrerpolicy="no-referrer" style="width:100%;height: 100%;position: fixed;object-fit: cover;z-index: -1;;" />
      <div style="background-color: rgba(0,0,0,0.4);width:100%;height:100%;display: flex;align-items: center;justify-content: center;">
			<div style="width:400px;height:400px;border-radius: 10px;background-color: white;display: flex;flex-direction: column;;align-items: center;;padding:20px">
				<p style="font-size: 20px;font-weight: 700">登录</p>
				<div style="width:80%;margin-bottom: 20px;margin-top: 10px;">
					<p style="margin-right: 10px;">账号</p><el-input v-model="account" placeholder="请输入账号"></el-input>
				</div>
				<div style="width:80%;margin-bottom: 30px;">
					<p style="margin-right: 10px;">密码</p><el-input type="password" v-model="password" placeholder="请输入密码"></el-input>	
				</div>
				 <el-button type="primary" style="width:80%" @click="login()">登录</el-button>
				 <el-button plain class="console-entry-button" @click="openConsole">进入控制台</el-button>
			</div>
      </div>
  </div>
 </template>
<script>
import {post} from "../axios/request.js"
export default {
  data() {
    return {
      account:"",
	  password:"",
    }
  },
  mounted() {
    if(localStorage.getItem("token")!=null&&localStorage.getItem("token").length==18){
        post("/api/admin/jugetoken",{token:localStorage.getItem("token")}).then((res)=>{
            if(res.data.code==1002){

            }else{
                this.$router.replace({path:"/index"})
            }
        })
    }
  },
  methods: {
	  login(){
		post("/api/admin/login",{account:this.account,password:this.password}).then((res)=>{
			if(res.data.code==1001){
				var time = new Date().getTime()+3600*1000*2;
				localStorage.setItem("time",time);
				localStorage.setItem("token",res.data.token);
				this.$router.replace({path:"/index"})
			}else{
				this.$message.error('账号或密码错误');
			}
		})
	  },
    openConsole(){
      this.$router.push({path:"/console"})
    }
  }
}
</script>

<style scoped>
.console-entry-button {
  width: 80%;
  margin-top: 12px;
  margin-left: 0;
}

</style>
